export const FETCH_SHOP_REVIEWS =
  'app/conversion/shopReviews/FETCH_SHOP_REVIEWS';
export const CLEAN_STATE = 'app/conversion/shopReviews/CLEAN_STATE';
